// @ts-nocheck
import React from "react";
/* eslint-disable import/no-anonymous-default-export */
const O = React.Fragment;

function format_number(floatval, n_decimals, thousand_separator, decimal_separator) {
	var intval = Math.round(floatval * Math.pow(10, n_decimals));

	var is_positive = true;
	if (intval < 0) {
		is_positive = false;
		intval = -intval;
	}

	intval = intval.toString();
	while (intval.length <= n_decimals) intval = "0" + intval;
	const fraction = intval.substring(intval.length - n_decimals);
	var rest = intval.substring(0, intval.length - n_decimals);
	var head = "";
	while (rest.length > 3) {
		head = thousand_separator + rest.substring(rest.length - 3) + head;
		rest = rest.substring(0, rest.length - 3);
	}
	head = rest + head;
	if (n_decimals > 0) head += (decimal_separator + fraction);
	return (is_positive ? "" : "-") + head;
}


function format_number_en(floatval, n_decimals) {
	return format_number(floatval, n_decimals, ",", ".");
}

function format_number_da(floatval, n_decimals) {
	return format_number(floatval, n_decimals, ".", ",");
}

const format_number_de = format_number_da; // deutsch is as danish


export default {
	"9f38ea14748d": {
		"_new": true, // FIXME remove this line when translation is done
		"_context": "123,456.78",
		"en": (n_decimals, val) => <O>{format_number_en(val, n_decimals)}</O>,
		"da": (n_decimals, val) => <O>{format_number_da(val, n_decimals)}</O>,
		"de": (n_decimals, val) => <O>{format_number_de(val, n_decimals)}</O>,
	},

	"31fef541ffbe": {
		"_new": true, // FIXME remove this line when translation is done
		"_context": "DKK 123,456.78",
		"en": (n_decimals, unit, val) => {
			switch (unit) {
				case "USD": return <O>${format_number_en(val, n_decimals)}</O>;
				case "EUR": return <O>€{format_number_en(val, n_decimals)}</O>;
				default:    return <O><span className="ps-2">{unit}</span>&nbsp;{format_number_en(val, n_decimals)}</O>;
			}
		},
		"da": (n_decimals, unit, val) => {
			switch (unit) {
				case "USD": return <O>${format_number_da(val, n_decimals)}</O>;
				case "EUR": return <O>€{format_number_da(val, n_decimals)}</O>;
				case "DKK": return <O>{format_number_da(val, n_decimals)}<span className="ps-2">kr.</span></O>;
				default:    return <O><span className="ps-2">{unit}</span>&nbsp;{format_number_da(val, n_decimals)}</O>;
			}
		},
		"de": (n_decimals, unit, val) => {
			switch (unit) {
				case "USD": return <O>${format_number_de(val, n_decimals)}</O>;
				case "EUR": return <O>€{format_number_de(val, n_decimals)}</O>;
				default:    return <O><span className="ps-2">{unit}</span>&nbsp;{format_number_de(val, n_decimals)}</O>;
			}
		},
	},

	"50d766c1801c": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>This is a required field</O>,
		"da": () => <O>This is a required field</O>,
		"de": () => <O>This is a required field</O>,
	},

	"1a9c4ae0b7f0": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Not a valid email</O>,
		"da": () => <O>Ugyldig e-mail</O>,
		"de": () => <O>Not a valid email</O>,
	},

	"5d27f844f291": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
		"da": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
		"de": () => <O>The password must be at least 8 caracters, and contain 1 uppase, 1 lower, and one special caracter</O>,
	},

	"11aa8134ce58": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Emails do not match</O>,
		"da": () => <O>Emails ikke ens</O>,
		"de": () => <O>Emails do not match</O>,
	},

	"28c53487292f": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Passwords do not match</O>,
		"da": () => <O>Passwords ikke ens</O>,
		"de": () => <O>Passwords do not match</O>,
	},

	"a864dbffc25e": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Phone</O>,
		"da": () => <O>Telefonnummer</O>,
		"de": () => <O>Phone</O>,
	},

	"c3fd690881ed": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Austria</O>,
		"da": () => <O>Østrig</O>,
		"de": () => <O>Austria</O>,
	},

	"d612ee652f49": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Belgium</O>,
		"da": () => <O>Belgien</O>,
		"de": () => <O>Belgium</O>,
	},

	"99e8c7f4d255": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Bulgaria</O>,
		"da": () => <O>Bulgarien</O>,
		"de": () => <O>Bulgaria</O>,
	},

	"ad5536311f44": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Croatia</O>,
		"da": () => <O>Kroatien</O>,
		"de": () => <O>Croatia</O>,
	},

	"c369b3c7a568": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Czechia</O>,
		"da": () => <O>Tjekkiet</O>,
		"de": () => <O>Czechia</O>,
	},

	"03dc7e209656": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Cyprus</O>,
		"da": () => <O>Cyprus</O>,
		"de": () => <O>Cyprus</O>,
	},

	"a32f5bbe4a7e": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Denmark</O>,
		"da": () => <O>Danmark</O>,
		"de": () => <O>Denmark</O>,
	},

	"4c3440127f9d": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Estonia</O>,
		"da": () => <O>Estland</O>,
		"de": () => <O>Estonia</O>,
	},

	"2542979ad8f7": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Finland</O>,
		"da": () => <O>Finland</O>,
		"de": () => <O>Finland</O>,
	},

	"6207155856aa": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>France</O>,
		"da": () => <O>Frankrig</O>,
		"de": () => <O>France</O>,
	},

	"aad4fb9baa30": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Germany</O>,
		"da": () => <O>Tyskland</O>,
		"de": () => <O>Germany</O>,
	},

	"bf2ac4d83c4f": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Greece</O>,
		"da": () => <O>Grækenland</O>,
		"de": () => <O>Greece</O>,
	},

	"b86e39d8a98c": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Hungary</O>,
		"da": () => <O>Ungarn</O>,
		"de": () => <O>Hungary</O>,
	},

	"317016c4b7c0": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Ireland</O>,
		"da": () => <O>Irland</O>,
		"de": () => <O>Ireland</O>,
	},

	"9fdddb178433": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Italy</O>,
		"da": () => <O>Italien</O>,
		"de": () => <O>Italy</O>,
	},

	"029b082b9298": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Latvia</O>,
		"da": () => <O>Letland</O>,
		"de": () => <O>Latvia</O>,
	},

	"5b26aa6dc25d": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Lithuania</O>,
		"da": () => <O>Litauen</O>,
		"de": () => <O>Lithuania</O>,
	},

	"ee51478fa420": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Luxembourg</O>,
		"da": () => <O>Luxemborg</O>,
		"de": () => <O>Luxembourg</O>,
	},

	"413bc122dfc1": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Malta</O>,
		"da": () => <O>Malta</O>,
		"de": () => <O>Malta</O>,
	},

	"d859d5355525": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Netherlands</O>,
		"da": () => <O>Nederlandene</O>,
		"de": () => <O>Netherlands</O>,
	},

	"ca3f26c249e4": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Norway</O>,
		"da": () => <O>Norge</O>,
		"de": () => <O>Norway</O>,
	},

	"b1c9245ed607": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Poland</O>,
		"da": () => <O>Polen</O>,
		"de": () => <O>Poland</O>,
	},

	"f6c12caddc40": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Portugal</O>,
		"da": () => <O>Portugal</O>,
		"de": () => <O>Portugal</O>,
	},

	"bc51f4753b8e": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Romania</O>,
		"da": () => <O>Romænien</O>,
		"de": () => <O>Romania</O>,
	},

	"3415c47f34d1": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Slovakia</O>,
		"da": () => <O>Slovakiet</O>,
		"de": () => <O>Slovakia</O>,
	},

	"3557e848d25f": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Slovenia</O>,
		"da": () => <O>Slovenien</O>,
		"de": () => <O>Slovenia</O>,
	},

	"f48602a2d111": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Spain</O>,
		"da": () => <O>Spanien</O>,
		"de": () => <O>Spain</O>,
	},

	"5dc734c0694a": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Sweden</O>,
		"da": () => <O>Sverige</O>,
		"de": () => <O>Sweden</O>,
	},

	"2029cac12895": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Non-EU country</O>,
		"da": () => <O>Ikke-EU land</O>,
		"de": () => <O>Non-EU country</O>,
	},

	"2a79ae72d838": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>First Name</O>,
		"da": () => <O>Fornavn</O>,
		"de": () => <O>First Name</O>,
	},

	"e8593a560786": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Please insert name</O>,
		"da": () => <O>Indtast navn</O>,
		"de": () => <O>Please insert name</O>,
	},

	"baf2c2d582d4": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>E-mail</O>,
		"da": () => <O>E-mail</O>,
		"de": () => <O>E-mail</O>,
	},

	"67f4612b3539": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Invalid email address</O>,
		"da": () => <O>Ugyldig email-adresse</O>,
		"de": () => <O>Invalid email address</O>,
	},

	"0ec5ef226f6a": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Street</O>,
		"da": () => <O>Gadenavn</O>,
		"de": () => <O>Street</O>,
	},

	"1cb96d32886d": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Please insert address</O>,
		"da": () => <O>Indtast adresse</O>,
		"de": () => <O>Please insert address</O>,
	},

	"bce24af2a49a": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Phone no.</O>,
		"da": () => <O>Tlf. nr.</O>,
		"de": () => <O>Phone no.</O>,
	},

	"06682977826f": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Please insert a phone number</O>,
		"da": () => <O>Indtast telefonnummer</O>,
		"de": () => <O>Please insert a phone number</O>,
	},

	"a91765df507e": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Use same address</O>,
		"da": () => <O>Brug samme adresse</O>,
		"de": () => <O>Use same address</O>,
	},

	"a11c9241d884": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Edit</O>,
		"da": () => <O>Redigér</O>,
		"de": () => <O>Edit</O>,
	},

	"1bd51c733efa": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Email:</O>,
		"da": () => <O>Email:</O>,
		"de": () => <O>Email:</O>,
	},

	"5a96c1385c1c": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Tlf.</O>,
		"da": () => <O>Tlf.</O>,
		"de": () => <O>Tlf.</O>,
	},

	"b5d0589ab594": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Change shipping address</O>,
		"da": () => <O>Redigér leveringsadresse</O>,
		"de": () => <O>Change shipping address</O>,
	},

	"af8ba3d21be0": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Billing Address</O>,
		"da": () => <O>Betalingsadresse</O>,
		"de": () => <O>Billing Address</O>,
	},

	"3520b68d9fe4": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"en": () => <O>Use as shipping address</O>,
		"da": () => <O>Brug som leveringsadresse</O>,
		"de": () => <O>Use as shipping address</O>,
	},

	"68fae65cdb35": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Continue to checkout</O>,
		"da": () => <O>Fortsæt til betaling</O>,
		"de": () => <O>Continue to checkout</O>,
	},

	"d976365de3d1": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Checkout</O>,
		"da": () => <O>Betaling</O>,
		"de": () => <O>Checkout</O>,
	},

	"d55c15a66b28": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => {
			return (
				<O>
					I agree to the
				</O>
			);
		},
		"da": () => {
			return (
				<O>
					Jeg er indforstået med
				</O>
			);
		},
		"de": () => {
			return (
				<O>
					I agree to the
				</O>
			);
		},
	},

	"625dd577bb43": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>terms of privacy</O>,
		"da": () => <O>privatlivsbetingelserne</O>,
		"de": () => <O>terms of privacy</O>,
	},

	"d98d94d0dd4d": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>terms of trade</O>,
		"da": () => <O>handelsbetingelerne</O>,
		"de": () => <O>terms of trade</O>,
	},

	"42295cbdeb74": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Read more</O>,
		"da": () => <O>Læs mere</O>,
		"de": () => <O>Read more</O>,
	},

	"03bc1fbd4130": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Choose amount</O>,
		"da": () => <O>Vælg antal</O>,
		"de": () => <O>Choose amount</O>,
	},

	"436ce7e31cee": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Details</O>,
		"da": () => <O>Detaljer</O>,
		"de": () => <O>Details</O>,
	},

	"b8bc8d9e60b2": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>ISBN</O>,
		"da": () => <O>ISBN</O>,
		"de": () => <O>ISBN</O>,
	},

	"adecf826ec60": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>days for delivery</O>,
		"da": () => <O>Leveringstid</O>,
		"de": () => <O>days for delivery</O>,
	},

	"80188a056bf4": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>2-5 days</O>,
		"da": () => <O>2-5 dage</O>,
		"de": () => <O>2-5 days</O>,
	},

	"10073da047bc": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>PRICE</O>,
		"da": () => <O>PRIS</O>,
		"de": () => <O>PRICE</O>,
	},

	"87d6dbcd12be": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>See less</O>,
		"da": () => <O>Se mindre</O>,
		"de": () => <O>See less</O>,
	},

	"a8d5e7033813": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Buy</O>,
		"da": () => <O>Køb</O>,
		"de": () => <O>Buy</O>,
	},

	"369201a4a181": {
		"_new": true, // FIXME remove this line when translation is done
		"en": (vat) => <O>{vat.repr} ({vat.rate}% inclusive)</O>,
		"da": (vat) => <O>{vat.repr} ({vat.rate}% inkluderet)</O>,
		"de": (vat) => <O>{vat.repr} ({vat.rate}% inclusive)</O>,
	},

	"268db5001df5": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Delivery</O>,
		"da": () => <O>Levering</O>,
		"de": () => <O>Delivery</O>,
	},

	"f28e37c63ec4": {
		"_new": true, // FIXME remove this line when translation is done
		"_deleted": true, // FIXME translation has no references; delete this entire section if you no longer need it
		"en": () => <O>Your package will be delivered to</O>,
		"da": () => <O>Din pakke bliver leveret til</O>,
		"de": () => <O>Your package will be delivered to</O>,
	},

	"a559f5ffb310": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Total</O>,
		"da": () => <O>Total</O>,
		"de": () => <O>Total</O>,
	},

	"b35600788537": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Net</O>,
		"da": () => <O>Net</O>,
		"de": () => <O>Net</O>,
	},

	"a7fbcb748f11": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Purchase complete!</O>,
		"da": () => <O>Købet er gennemført!</O>,
		"de": () => <O>Purchase complete!</O>,
	},

	"77c10a73f046": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Order Id</O>,
		"da": () => <O>Ordre ID</O>,
		"de": () => <O>Order Id</O>,
	},

	"bac9285ec77a": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Continue to delivery</O>,
		"da": () => <O>Fortsæt til levering</O>,
		"de": () => <O>Continue to delivery</O>,
	},

	"b056b6874904": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Shipping Address</O>,
		"da": () => <O>Leveringsadresse</O>,
		"de": () => <O>Shipping Address</O>,
	},

	"bf9a75e69f42": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Zip/Postal Code</O>,
		"da": () => <O>Postnummer</O>,
		"de": () => <O>Zip/Postal Code</O>,
	},

	"cdd7ef1c9be8": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Invalid Zip/Postal Code</O>,
		"da": () => <O>Ugyldigt postnummer</O>,
		"de": () => <O>Invalid Zip/Postal Code</O>,
	},

	"62a492bcffb7": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>City</O>,
		"da": () => <O>By</O>,
		"de": () => <O>City</O>,
	},

	"b1097c525d8f": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Please insert city</O>,
		"da": () => <O>Indtast by</O>,
		"de": () => <O>Please insert city</O>,
	},

	"cb5057b9da38": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Country</O>,
		"da": () => <O>Land</O>,
		"de": () => <O>Country</O>,
	},

	"e4432538431e": {
		"_new": true, // FIXME remove this line when translation is done
		"en": () => <O>Last Name</O>,
		"da": () => <O>Efternavn</O>,
		"de": () => <O>Last Name</O>,
	},
}
